/* RESPONSIBLE TEAM: team-frontend-tech */
/* === ⚠️ THIS FILE CURRENTLY USES DEPRECATED PATTERNS ⚠️ === */
/* === 🔗 For more information visit https://go.inter.com/ember-best-practices 🔗 */
/* === 🚀 Please consider refactoring & removing some of the comments below when working on this file 🚀 */
/* eslint-disable @intercom/intercom/no-bare-strings */
import DefaultPredicateComparisonOptions from 'predicates/models/data/default-predicate-comparison-options';
const ATTRIBUTE_OPTION_SELECT_COMPARISONS = {
  comparison: [{
    label: 'is',
    value: 'eq'
  }, {
    label: 'is not',
    value: 'ne'
  }, {
    label: 'starts with',
    value: 'starts_with',
    ignoreOptions: true
  }, {
    label: 'ends with',
    value: 'ends_with',
    selected: false,
    ignoreOptions: true
  }, {
    label: 'contains',
    value: 'contains',
    ignoreOptions: true
  }, {
    label: 'does not contain',
    value: 'not_contains',
    ignoreOptions: true
  }, {
    label: 'is unknown',
    value: 'unknown'
  }, {
    label: 'has any value',
    value: 'known'
  }]
};
const vamOptions = {
  custom: {
    'client_attributes.time_on_page': {
      numeric: {
        comparison: [{
          label: 'is equal to',
          value: 'eq',
          suffix: 'second',
          minimumValue: 1
        }]
      }
    }
  },
  attributeOptionSelect: ATTRIBUTE_OPTION_SELECT_COMPARISONS
};
let mergedOptions = Object.assign({}, DefaultPredicateComparisonOptions, vamOptions);
export default mergedOptions;